import React from 'react';
import { View } from 'react-native';
import { LEVELS, searchDisplayMode } from '@helpers';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import ModeSelectorItem from './ModeSelectorItem';
import { ModeSelectorProps } from './types';
import { isWeb } from '@helpers';
import { SCREEN_BORDER_RADIUS, TEST_IDS } from '@v2/pages/common/constants/base.constants';

const ModeSelector = ({
  displayMode,
  setSelectedDisplayMode,
  C,
  level,
  bg,
  disabledModes,
  scale = initialScale,
  font = initialFont,
}: ModeSelectorProps) => {
  const isToolsLevel = level === LEVELS.Tools;
  const isDetailsScreenImagesDocumentsLevel = level === LEVELS.DetailsScreenImagesDocuments;

  const modesData = [
    ...(isDetailsScreenImagesDocumentsLevel ? [{ iconUrl: 'gallery', mode: searchDisplayMode.gallery, width: 18, height: 16 }] : []),
    { iconUrl: 'fullItem', mode: searchDisplayMode.block, width: 16, height: 20 },
    ...(level === LEVELS.ProductionBatches || level === LEVELS.Operations
      ? [{ iconUrl: 'infoTilesView', mode: searchDisplayMode.infoTiles, width: 18, height: 16 }]
      : []),
    { iconUrl: 'standardList', mode: isWeb ? searchDisplayMode.tableStandard : searchDisplayMode.line, width: 16, height: 13 },
    { iconUrl: 'compactList', mode: searchDisplayMode.tableCompact, onlyWeb: true, width: 16, height: 10 },
    ...(!isToolsLevel ? [{ iconUrl: 'squares', mode: searchDisplayMode.square, width: 16, height: 16 }] : []),
  ];

  const filteredModesData = disabledModes ? modesData.filter((modeData) => !disabledModes.some((m) => modeData.mode === m)) : modesData;

  return (
    <View
      style={{
        flexDirection: 'row',
        height: scale(36),
        backgroundColor: C(bg ?? 'Gray/Light/5'),
        borderRadius: scale(SCREEN_BORDER_RADIUS),
        alignItems: 'center',
        padding: scale(3),
        gap: scale(5),
      }}
    >
      {filteredModesData
        .filter((i) => (isWeb ? true : !i.onlyWeb))
        .map(({ mode, iconUrl, width, height }) => (
          <ModeSelectorItem
            key={mode}
            {...{
              ...(width ? { width } : {}),
              ...(height ? { height } : {}),
              C,
              onPress: () => {
                setSelectedDisplayMode(mode);
              },
              iconUrl,
              mode,
              currentMode: displayMode,
              scale,
              font,
              testID: `${TEST_IDS.searchScreen.modeSelectorItem}-${mode}`,
            }}
          />
        ))}
    </View>
  );
};

export default ModeSelector;
